export default "__VITE_ASSET__$5Wg_F_D__"